/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/391-mail4': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM4 4h8c.143 0 .281.031.409.088L8 9.231 3.591 4.088A.982.982 0 014 4zm-1 7V5l.002-.063 2.932 3.421-2.9 2.9A.967.967 0 013 11zm9 1H4c-.088 0-.175-.012-.258-.034L6.588 9.12l1.413 1.648L9.414 9.12l2.846 2.846a.967.967 0 01-.258.034zm1-1c0 .088-.012.175-.034.258l-2.9-2.9 2.932-3.421L13 5v6z"/>'
  }
})
